import React, { PropsWithChildren, useRef, useState } from "react";
import IconButton from "components/common/Button/IconButton";
import styles from "./index.module.scss";
import ChevronUpIcon from "assets/icons/ChevronUpIcon";
import { IAccordionListProps } from "types/components/common/accordion";
import { getSettings } from "store/slices";
import { useAppSelector } from "store/hooks";

const Accordion = ({
  renderBody,
  renderHeader,
  headerClassName,
  hideDropdownbtn,
  item,
  idx,
}: {
  renderBody: (item: any) => JSX.Element;
  renderHeader: (item: any) => JSX.Element;
  headerClassName?: string;
  hideDropdownbtn?: boolean;
  item: any;
  idx: number;
}) => {
  const [activeItem, setActive] = useState<number | null>(null);
  const contentElement = useRef<HTMLDivElement>(null);
  const [isOpened, setOpened] = useState<boolean>(false);
  const [height, setHeight] = useState("0px");
  const HandleOpening = () => {
    setOpened(!isOpened);
    setHeight(!isOpened ? `${contentElement?.current?.scrollHeight}px` : "0px");
  };
  return (
    <div
      className={`${styles["accordion-item"]}`}
      key={`--accordion-item-${idx}`}
    >
      <div
        className={`${styles["accordion-header"]} ${headerClassName || ""}`}
        onClick={() => {
          setActive(activeItem === idx ? null : idx);
          HandleOpening();
        }}
      >
        {renderHeader(item)}{" "}
        {!hideDropdownbtn && (
          <IconButton
            icon={
              <ChevronUpIcon
                fill="#004E99"
                size={12}
                className={`transition-all duration-500 ${
                  activeItem === idx ? "" : "rotate-180"
                }`}
              />
            }
          />
        )}
      </div>
      <div
        className={styles["accordion-body"]}
        aria-expanded={activeItem === idx}
        ref={contentElement}
        style={{ height: `${height}` }}
      >
        {renderBody(item)}
      </div>
    </div>
  );
};

const AccordionList = <T,>({
  items,
  renderBody,
  renderHeader,
  headerClassName,
  wrapperClassName,
  hideDropdownbtn,
}: PropsWithChildren<IAccordionListProps<T>>) => {
  const { dir, language } = useAppSelector(getSettings);

  return (
    <div
      className={`${styles["accordion-list"]} ${wrapperClassName || ""}`}
      dir={dir}
      lang={language}
    >
      {items.map((item, idx) => (
        <Accordion
          renderBody={renderBody}
          renderHeader={renderHeader}
          headerClassName={headerClassName}
          hideDropdownbtn={hideDropdownbtn}
          item={item}
          idx={idx}
          key={`--accordion-${idx}`}
        />
      ))}
    </div>
  );
};

export default AccordionList;
